import { ProductRelationItem, ProductRelationType, StockType, Variant } from '@/types';

/**
 * Filter relations articles based on stock type combination and quantity
 * If relation type is "reservdel", do not filter articles
 * If variant has stockType LAG the relations with stockType other than LAG should be removed
 * If relation has stockType LAG the stock quantity must be greater than 0
 */
export function filterRelatedArticlesByType(variantStockType: StockType, relationType: ProductRelationType) {
  const nonFilteredTypes = ['reservdel', 'tillbehor'];
  return function (relationArticle: Variant | null) {
    if (!relationArticle) return false;

    if (nonFilteredTypes.includes(relationType?.toLowerCase())) {
      return true;
    }

    if (!relationArticle?.stock || !variantStockType) {
      return true;
    }

    const variantStockTypeIsLAG = variantStockType.toUpperCase() === STOCK_TYPE.WAREHOUSE;
    const relationStockTypeIsLAG = relationArticle.stock.stockType?.toUpperCase() === STOCK_TYPE.WAREHOUSE;

    if (variantStockTypeIsLAG) {
      return relationStockTypeIsLAG;
    }

    return true;
  };
}

/**
 * Upper section relations should display two articles and then a category if
 * < 1 articles and any category exists
 */
export function sortUpperSectionRelations(relationItems: ProductRelationItem[]) {
  const categories = relationItems.filter((item) => item.slug);
  const articles = relationItems.filter((item) => !item.slug);

  if (!categories.length || !(articles.length > 1)) return relationItems;

  const itemsCopy = [...relationItems];
  const itemsToMove = [articles[0], articles[1], categories[0]];
  const result = [];

  for (const itemToMove of itemsToMove) {
    const index = itemsCopy.findIndex((item) => item === itemToMove);
    const [spliced] = itemsCopy.splice(index, 1);
    result.push(spliced);
  }

  return [...result, ...itemsCopy];
}
